import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { CacheService, ITypeJobBO, ITypeStateJobBO, ITypeReasonCloseBO, IJobOriginBO } from '@mapfre-tech/amap3';

type OriginWorkBody = { txtOrg?: string; isActive: number };
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WorkService {

  className = 'WorkService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  /**
 *  Work Origin
 */

  getAllOriginWorks(cache = true, cacheKey = "allOriginWorks"): Observable<IJobOriginBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IJobOriginBO[]>;
    } else {
      const observable = this.http.get<IJobOriginBO[]>(environment.base_URL + "/origin").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newOriginWork(work: OriginWorkBody) {
    return this.http.post(environment.base_URL + "/origin", work).pipe(tap(() => this.deleteCache()));
  }

  updateOriginWork(work: OriginWorkBody, id: number) {
    return this.http.put(environment.base_URL + `/origin/${id}`, work).pipe(tap(() => this.deleteCache()));
  }

  deleteCache() {
    this.cacheService.deleteCache('allOriginWorks');
  }

  /**
   *  Work types
   */

  getAllWorkTypes(cache = true, cacheKey = "allWorkTypes"): Observable<ITypeJobBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeJobBO[]>;
    } else {
      const observable = this.http.get<ITypeJobBO[]>(environment.base_URL + "/jobs/type").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newWorkType(work: ITypeJobBO) {
    return this.http.post(environment.base_URL + "/jobs/type", work).pipe(tap(() => this.cacheService.deleteCache('allWorkTypes')))
  }

  updateWorkType(work: ITypeJobBO, id: number) {
    return this.http.put(environment.base_URL + `/jobs/type/${id}`, work).pipe(tap(() => this.cacheService.deleteCache('allWorkTypes')))
  }

  /**
 *  Work Status
 */

  getAllWorkStatus(cache = true, cacheKey = "allWorkStatus"): Observable<ITypeStateJobBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeStateJobBO[]>;
    } else {
      const observable = this.http.get<ITypeStateJobBO[]>(environment.base_URL_GAIA + "/job_state_types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newWorkStatus(work: ITypeStateJobBO) {
    return this.http.post(environment.base_URL + "/jobs/state", work).pipe(tap(() => this.cacheService.deleteCache('allWorkStatus')))
  }

  updateWorkStatus(work: ITypeStateJobBO, id: number) {
    return this.http.put(environment.base_URL + `/jobs/state/${id}`, work).pipe(tap(() => this.cacheService.deleteCache('allWorkStatus')))
  }

  /**
  *  Work Reason Cancel 
  */

  getAllWorkReasons(cache = true, cacheKey = "allWorkReasonsClose"): Observable<ITypeReasonCloseBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeReasonCloseBO[]>;
    } else {
      const observable = this.http.get<ITypeReasonCloseBO[]>(environment.base_URL + "/jobs/reason-close").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newWorkReason(work: Omit<ITypeReasonCloseBO, 'idReasonClosePk'>) {
    return this.http.post(environment.base_URL + "/jobs/reason-close", work).pipe(tap(() => this.cacheService.deleteCache('allWorkReasonsClose')))
  }

  updateWorkReason(work: Omit<ITypeReasonCloseBO, 'idReasonClosePk'>, id: number) {
    return this.http.put(environment.base_URL + `/jobs/reason-close/${id}`, work).pipe(tap(() => this.cacheService.deleteCache('allWorkReasonsClose')))
  }
}
